import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { RawHTML } from '@wordpress/element';
import useCustomCssBlockProps from '../Common/useCustomCssBlockProps';
const DefaultCssClasses = 'wp-block-leadin-hubspot-form-block';
export default function FormSaveBlock({ attributes }) {
    const { portalId, formId } = attributes;
    const blockProps = useCustomCssBlockProps(DefaultCssClasses);
    if (portalId && formId) {
        return (_jsx(RawHTML, { ...blockProps, children: `[hubspot portal="${portalId}" id="${formId}" type="form"]` }));
    }
    return null;
}
